import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap, take } from 'rxjs/operators';
import { B2CEmployeeDataControllerService } from '@iota/inh-core-v1-management-client';
import { LoadB2CPayments, LoadB2CPaymentsSuccess, LoadB2CPaymentsFailure } from '../actions/b2c-employee.actions';

@Injectable()
export class B2CEmployeeEffects {
    loadB2CPayments$ = createEffect(() =>
        this.actions$.pipe(
            ofType(LoadB2CPayments),
            mergeMap(({ employeeId }) =>
                this.b2cService.getPayments(employeeId).pipe(
                    take(1),
                    map((payments) => LoadB2CPaymentsSuccess({ payments })),
                    catchError((error) => of(LoadB2CPaymentsFailure({ error })))
                )
            )
        )
    );

    constructor(
        private actions$: Actions,
        private b2cService: B2CEmployeeDataControllerService
    ) {}
}
